import { createRsSDK } from './core.js';
import { createBbCommands } from './bb/feature.js';
import { applyBbFromConfig } from './bb/auto-config.js';
import { createBbDevTools } from './bb-devtools/index.js';

const baseRsSDK = createRsSDK({ createBbCommands, applyBbFromConfig });
const bbDevTools = createBbDevTools(baseRsSDK);
const wrapped = bbDevTools.wrapRsSDK(baseRsSDK);

// Queued config may have already set debug before DevTools existed.
bbDevTools.mountIfEnabled();

export default wrapped;
